<template>
  <v-row class="px-4 pt-3 pb-4 details-policy__card-auto">
    <v-col cols="12">
      <p class="primary--text font-weight-bold mb-3">
        CERTIFICADOS
      </p>
    </v-col>
    <v-col cols="12" sm="6" class="pb-3 pr-sm-4">
      <v-row class="details-policy__item px-3 py-4">
        <v-col cols="6">
          <p class="subtitle-2 primary--text mb-0 details-policy__title-height" style="line-height:40px!important">
            Administradores e Regularidade
          </p>
        </v-col>
        <v-col cols="6" class="d-flex justify-sm-end">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <BaseButton color="secondary" class="px-0 mr-2 details-policy__button" @click="downloadCertificates(0)">
                  <v-icon>
                    $vuetify.icons.fileCertificate
                  </v-icon>
                  1
                </BaseButton>
              </div>
            </template>
            <span>
              Certidão de Administradores
            </span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <BaseButton color="secondary" class="px-0 mr-2 details-policy__button" @click="downloadCertificates(1)">
                  <v-icon>
                    $vuetify.icons.fileCertificate
                  </v-icon>
                  2
                </BaseButton>
              </div>
            </template>
            <span>
              Certidão de Regularidade
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="6" class="pb-3">
      <v-row class="details-policy__item px-3 py-4">
        <v-col cols="6">
          <p class="subtitle-2 primary--text mb-0 details-policy__title-height" style="line-height:40px!important">
            Registro de Apólice
          </p>
        </v-col>
        <v-col cols="6" class="d-flex justify-sm-end">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <BaseButton color="secondary" class="px-0 mr-2 details-policy__button" @click="openRegistryWindow">
                  <v-icon>
                    $vuetify.icons.fileSigned
                  </v-icon>
                </BaseButton>
              </div>
            </template>
            <span>
              Iniciar Consulta
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>
    <v-icon class="pl-4 pr-4" small>
      fa-info
    </v-icon>
    <p class="caption darkBluishGray--text mt-1 mb-0 font-weight-medium details-policy__text-height">
      Registro SUSEP – Extraído em até 7 dias úteis após a data de emissão da apólice, conforme Circular SUSEP 326 de 29/05/2006.
    </p>
  </v-row>
</template>
<script>
import { api } from "@/api";
export default {
  methods: {
    async downloadCertificates(index) {
      let { data } = await api.get(`/v1/seguradoras/documentos/${this.seguradoraId }`);
      window.open(data[index].arquivo_link, data[index].tipo_documento);
    },

    openRegistryWindow() {
      window.open('https://www2.susep.gov.br/safe/menumercado/regapolices/pesquisa.asp', 'SUSEP').focus();
    }
  },
  props: {
    seguradoraId: {
      type: String
    }
  }
};
</script>
<style lang="sass">
.details-policy__
  &title
    align-self: center
  &card
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
    @media(min-width: 960px)
      height: 285px
  &card-auto
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
  &item
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FFFFFF
  &button
    min-width: 40px !important
  &border-success
    border-left: 5px solid #49DCBB
  &border-green
    border-left: 5px solid #49DCBB
  &border-yellow
    border-left: 5px solid #FFC55F
  &border-pink
    border-left: 5px solid #EF5350
  &value
    font-size: 12px
    font-weight: 600
  &text-height
    line-height: 16px !important
  &title-height
    line-height: 18px !important
  &disclaimer
    @media(min-width: 600px) and (max-width: 960px)
      height: 40px
    @media(min-width: 1440px)
      height: 40px
    border-radius: 4px
  &money
    font-size: 25px
    font-weight: 800
    line-height: 18px
  &table.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
    tbody tr td:first-child
      padding: 2px 0px !important
  &table-padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.endorsement-list__
  &col
    align-self: center
  &tab
    .v-tabs-bar
      height: 50px !important
</style>
